export const requiredValidation = message => value =>
    (value || typeof value === 'number'
        ? undefined
        : message || 'Required');

export const emailValidation = message => value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? message || 'Invalid email address'
        : undefined;

export const phoneNumberValidation = message => value =>
    value && !/^([0-9]+)$/i.test(value)
        ? message || 'Invalid phone number'
        : undefined

export const urlValidation = message => value => {
    const pattern = new RegExp('^http(s)??:\\/\\/'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

    return !!pattern.test(value) ? undefined : message || 'Invalid url address';
};

export const urlsValidation = message => value => {
    const urls = value ? value.split(/\r?\n/) : [];
    let hasError = false;

    urls.map(url => {
        if (url && urlValidation()(url) !== undefined) {
            hasError = true;
        }
    });

    return hasError ? message || 'Invalid url address' : undefined;
};

export const limitValidation = limit => message => value => {
    value = typeof value === 'string' ? value.length : parseInt(value);

    return value <= limit ? undefined : message || 'Max length '+limit+' characters.';
};

export const positiveNumberValidation = message => value =>
    !Math.sign(value) ? message : undefined;